import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, withKeys as _withKeys, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31c06cdd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "password-icon-buttons-container" }

import BaseInput from "@/ui-library/base-input/base-input.vue";
import PasswordVisibilityToggleButton from "./password-visibility-toggle-button.vue";
import { useToggledValue } from "@/composition/use-toggled-value";
import { TextAlignProperty } from "csstype";
import passwordStrengthGuide from "./password-strength-guide.vue";

// This component is a wrapper around the base input component that adds a password visibility toggle button and a password strength guide.
// More icon buttons can be added by passing them in as slots.
// Password strength bar can be turned on by passing in the prop isPasswordStrengthGuideOn as true

export default /*#__PURE__*/_defineComponent({
  __name: 'password-input',
  props: {
    modelValue: null,
    label: null,
    tabIndex: null,
    autocomplete: { default: "off" },
    textAlign: { default: "left" },
    isPasswordStrengthGuideOn: { type: Boolean, default: false }
  },
  setup(__props: any) {



const { isTrue: isPasswordVisible, toggleValue: togglePasswordVisibility } =
  useToggledValue({ defaultValue: false });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseInput, {
    class: "password-input-container",
    name: "password",
    modelValue: __props.modelValue,
    onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value))),
    type: _unref(isPasswordVisible) ? 'text' : 'password',
    tabindex: __props.tabIndex,
    label: __props.label,
    autocomplete: __props.autocomplete,
    textAlign: __props.textAlign,
    onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (_ctx.$emit('signIntoApp')), ["enter"]))
  }, {
    default: _withCtx(() => [
      (__props.isPasswordStrengthGuideOn && __props.modelValue)
        ? (_openBlock(), _createBlock(passwordStrengthGuide, {
            key: 0,
            password: __props.modelValue
          }, null, 8, ["password"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(PasswordVisibilityToggleButton, {
          class: "visibility-toggle-button",
          isPasswordVisible: _unref(isPasswordVisible),
          onTogglePasswordVisibility: _unref(togglePasswordVisibility)
        }, null, 8, ["isPasswordVisible", "onTogglePasswordVisibility"]),
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["modelValue", "type", "tabindex", "label", "autocomplete", "textAlign"]))
}
}

})